/* eslint-disable no-useless-concat */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable array-callback-return */
/* eslint-disable new-parens */
import React, { useEffect, useState, useRef } from 'react';

import configuration from '../../config';
import { elexity } from '../../utilities/BatteryAllocationGraphHelper';
import { useCampusMeta } from '../../context/CampusContextProvider';
import { useBatteryData } from '../../features/Devices/useDevicesQueries';
import { useLocalData } from '../../hooks/useLocalData';
import icon_edit from '../../assets/icon_edit.svg';
import icon_info from '../../assets/icon_info.svg';

require('highcharts/modules/accessibility');
require('highcharts/modules/draggable-points');
require('highcharts/modules/exporting');
require('highcharts/modules/export-data');

import BatterySocLevels from './BatterySocLevels';
import BatteryTotalsCards from './BatteryTotalsCards';
import './BatteryContent.scss';

const BatteryContent = ({ currentCampusId, openBatteryModal, showMobile }) => {
  const [showOutageRisk, setShowOutageRisk] = useState(false);
  const [batteryDataRender, setBatteryDataRender] = useState(null);

  const batteryAllocationRef = useRef(null);
  const batteryHistoryRef = useRef(null);
  const initialized = useRef(false);

  const { campusName } = useCampusMeta();
  const { data: batteryData } = useBatteryData(currentCampusId);
  const { getLocalData, APP_AUTH_STORAGE_KEY, APP_AUTH_TOKEN_KEY } = useLocalData();
  const getAuthHeaders = () => ({
    Authorization: `Bearer ${getLocalData(APP_AUTH_STORAGE_KEY)?.[APP_AUTH_TOKEN_KEY] ?? ''}`,
  });

  useEffect(() => {
    if (batteryData && !initialized.current) {
      initialized.current = true;
      batteryData.gridInterconnects.forEach((gx) => {
        elexity.gx.battery.init(
          batteryData,
          gx.gridInterconnectEntityKey,
          configuration['backend_host'] +
            '/admin/monitor/' +
            `${gx.gridInterconnectEntityKey}` +
            '/gxbattery/graphData/history',
          getAuthHeaders(),
          showMobile
        );
      });
    }
  }, [batteryData]);

  useEffect(() => {
    elexity.gx.battery.allocationGraph = {};
  }, [currentCampusId]);

  useEffect(() => {
    if (batteryData) {
      sortBatteryData();
      let gxId;

      batteryData.gridInterconnects.map((batteries) => {
        gxId = batteries.gridInterconnectEntityKey;
        setShowOutageRisk(batteries.backupPowerSupported);

        batteries.acBatteries = batteries.acBatteries.sort((a, b) => {
          if (a.entityKey - b.entityKey) {
            return 1;
          }
          if (a.entityKey < b.entityKey) {
            return -1;
          }
          return 0;
        });
      });

      if (
        batteryData.gridInterconnects &&
        batteryAllocationRef.current &&
        batteryHistoryRef.current
      ) {
        let interval = setInterval(() => {
          elexity.gx.battery.renderGraphs(
            batteryData,
            configuration['backend_host'] +
              '/admin/monitor/' +
              `${gxId}` +
              '/gxbattery/graphData/history',
            getAuthHeaders(),
            showMobile
          );
        }, 5000);

        return () => clearInterval(interval);
      }
    }
  }, [batteryData]);

  function formatDate(date) {
    let year = date.substring(0, 4);
    let month = date.substring(5, 7);
    let day = date.substring(8, 12);

    let formattedDate = `${month}/${day}/${year}`;

    return formattedDate;
  }

  function sortBatteryData() {
    const batteryDataCopy = { ...batteryData };
    batteryDataCopy.gridInterconnects.map((batteries) => {
      batteries.acBatteries = batteries.acBatteries.sort((a, b) => {
        const aDescription = a.longDescription ? a.longDescription : a.entityKey;
        const bDescription = b.longDescription ? b.longDescription : b.entityKey;
        if (aDescription - bDescription) {
          return 1;
        }
        if (aDescription < bDescription) {
          return -1;
        }
        return 0;
      });
    });

    setBatteryDataRender({
      ...batteryData,
      gridInterconnects: batteryDataCopy.gridInterconnects,
    });
  }

  return (
    <div>
      {batteryDataRender && batteryDataRender.gridInterconnects && (
        <>
          {batteryDataRender.gridInterconnects.map((item, index) => {
            const renderHeading = () => {
              if (campusName) {
                return campusName;
              }
              return item.gridInterconnectEntityKey;
            };

            return (
              <React.Fragment key={`section-${index}`}>
                <div className="gx-container">
                  {batteryDataRender.gridInterconnects.length > 1 && <div>z</div>}
                  <h3 className="gx-name">{renderHeading()}</h3>

                  <div className="section-block battery-summary-container">
                    <BatteryTotalsCards item={item} />

                    <hr className="extra-margin" />

                    <BatterySocLevels socPercent={item.socPercent} tactics={item.allocations} />

                    <hr className="extra-margin" />

                    <div
                      id={`history-graph-${item.gridInterconnectEntityKey}`}
                      className="history-graph"
                      ref={batteryHistoryRef}
                    ></div>
                  </div>

                  {item.acBatteries.map((battery, index) => (
                    <React.Fragment key={`battery-${index}`}>
                      <div className="battery-container">
                        <div className="name-battery-container">
                          <p className="subhead">
                            {battery.longDescription && battery.longDescription !== null
                              ? battery.longDescription
                              : battery.entityKey}
                          </p>

                          <div className="battery-soc-graphic">
                            <img
                              className="icon"
                              src={require(
                                `../../assets/kiosk/battery${item.batteryDisplaySoc}.svg`
                              )}
                              alt="Current Battery SOC % graphic"
                              width="80"
                              height="80"
                            />
                          </div>
                        </div>

                        <div className="charging-container">
                          <p className="group-subhead">Charging</p>

                          <div className="all-categories">
                            <div className="categories">
                              <p className="category">Battery SOC</p>
                              <p className="value">{`${battery.socPercentage}% / ${battery.sockWh}kWh`}</p>
                            </div>

                            <div className="categories">
                              <p className="category">Current Power</p>
                              <p className="value">{`${battery.realPowerkW}kW`}</p>
                            </div>

                            <div className="categories">
                              <p className="category">Capacity</p>
                              <p className="value">{`${battery.capacitykWh}kWh`}</p>
                            </div>

                            <div className="categories">
                              <p className="category">Max Charge</p>
                              <p className="value">{`${battery.chargeCapacitykW}kW`}</p>
                            </div>

                            <div className="categories">
                              <p className="category">Max Discharge</p>
                              <p className="value">{`${battery.dischargeCapacitykW}kW`}</p>
                            </div>
                          </div>
                        </div>

                        <div className="cell-container">
                          <div className="cell-temp">
                            <p className="group-subhead">Cell Temp</p>

                            <div className="category-container">
                              <div className="pill cell max">
                                <p className="category">Max</p>
                                <p className="value">
                                  {battery.maxCellTemperature === null
                                    ? `--`
                                    : `${battery.maxCellTemperature.toFixed(2)}° C`}
                                </p>
                              </div>

                              <div className="pill cell avg">
                                <p className="category">Avg</p>
                                <p className="value">
                                  {battery.maxCellTemperature + battery.minCellTemperature / 2 ===
                                  'NaN'
                                    ? `--`
                                    : `${(battery.maxCellTemperature + battery.minCellTemperature / 2).toFixed(2)}° C`}
                                </p>
                              </div>

                              <div className="pill cell min">
                                <p className="category">Min</p>
                                <p className="value">
                                  {battery.minCellTemperature === null
                                    ? `--`
                                    : `${battery.minCellTemperature.toFixed(2)}° C`}
                                </p>
                              </div>
                            </div>
                          </div>

                          <div className="cell-volt">
                            <p className="group-subhead">Cell Volt</p>

                            <div className="category-container">
                              <div className="pill cell max">
                                <p className="category">Max</p>
                                <p className="value">
                                  {battery.maxCellVoltage === null
                                    ? `--`
                                    : `${battery.maxCellVoltage.toFixed(2)} V`}
                                </p>
                              </div>

                              <div className="pill cell avg">
                                <p className="category">Avg</p>
                                <p className="value">
                                  {battery.maxCellVoltage + battery.minCellVoltage / 2 === 'NaN'
                                    ? `--`
                                    : `${(battery.maxCellVoltage + battery.minCellVoltage / 2).toFixed(2)} V`}
                                </p>
                              </div>

                              <div className="pill cell min">
                                <p className="category">Min</p>
                                <p className="value">
                                  {battery.minCellVoltage === null
                                    ? `--`
                                    : `${battery.minCellVoltage.toFixed(2)} V`}
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </React.Fragment>
                  ))}

                  <div className="battery-table">
                    <h3>Daily Charge/Discharge</h3>

                    <table>
                      <thead>
                        <tr>
                          <th>Date</th>
                          <th>Charge (kWh)</th>
                          <th>Discharge (kWh)</th>
                        </tr>
                      </thead>

                      <tbody>
                        {item.dayActivities.map((activity, index) => (
                          <tr key={`battery-table-${index}`}>
                            <td>{formatDate(activity.date)}</td>
                            <td>{activity.chargekW}</td>
                            <td>{activity.dischargekW}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </React.Fragment>
            );
          })}
        </>
      )}
    </div>
  );
};

export default BatteryContent;
